
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privpol",
      function () {
        return require("private-next-pages/privpol.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privpol"])
      });
    }
  